module.exports = __webpack_public_path__ + "static/media/NCSC.13686d73.PNG";